import { render, staticRenderFns } from "./commonNoData.vue?vue&type=template&id=42ed6069&scoped=true"
import script from "./commonNoData.vue?vue&type=script&lang=js"
export * from "./commonNoData.vue?vue&type=script&lang=js"
import style0 from "./commonNoData.vue?vue&type=style&index=0&id=42ed6069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed6069",
  null
  
)

export default component.exports